import React, { createContext, useContext, useState, useMemo, ReactNode } from 'react';

interface IHeaderVisibilityContext {
  isHeaderVisible: boolean;
  setHeaderVisible: (visible: boolean) => void;
}

const HeaderVisibilityContext = createContext<IHeaderVisibilityContext | undefined>(undefined);

export const HeaderVisibilityProvider = ({ children }: { children: ReactNode }) => {
  const [isHeaderVisible, setHeaderVisible] = useState(true);

  const value = useMemo(
    () => ({
      isHeaderVisible,
      setHeaderVisible,
    }),
    [isHeaderVisible]
  );

  return (
    <HeaderVisibilityContext.Provider value={value}>{children}</HeaderVisibilityContext.Provider>
  );
};

export const useHeaderVisibility = () => {
  const context = useContext(HeaderVisibilityContext);
  if (!context) {
    throw new Error('useHeaderVisibility must be used within a HeaderVisibilityProvider');
  }
  return context;
};
